import { setOptions, addRemote } from 'jack-logs';
import logEntries from 'jack-logs/services/logEntries';

export default function setupJack(store) {
  setOptions({
    contextRetriever: state => ({
      device: state.getIn(['device', 'deviceId']),
      authUserId: state.getIn(['account', 'userId']),
      version: process.env.LOG_VERSION,
    }),
    getState: store.getState,
    production: process.env.NODE_ENV === 'production',
    test: process.env.NODE_ENV === 'test',
  });

  addRemote(logEntries('29a25b1a-453a-446e-89ad-ac7b7db970c3'));
}

export const logActions = {
  APPLICATION_BOOT: 'application_boot',
};



// WEBPACK FOOTER //
// ./src/lib/jack.js